import React, { useState, useEffect } from "react";
import useCustomerInfo from "../../hooks/useCustomerInfo";
import PopSelectAddress from "../../pages/Home/Components/Popups/CartPages/PopSelectAddress";
import { useTranslation } from "react-i18next";
import { AddressInterface } from "../../pages/Home/Components/Popups/CartPages/utils";
import {
  getDeliveryZonseInfo,
  getGeocodeLoc,
  selectedOutInfo,
  saveLabelAndAddressToStorage,
} from "../../helper/MatchLocation";
import { useParams } from "react-router-dom";
import PopDelivery from "../../pages/Home/Components/Popups/PopDelivery";
import { useAppSelector } from "../../hooks/useRedux";
import { getShopDataFromStrg } from "../../pages/Home/utils";
interface SelectReciverModalProps {
  onPressClose: (
    selectedItem?: AddressInterface,
    buttonPress?: string | undefined
  ) => void;
  accesssToken: string;
  selectedLatLng: any;
  customerId: string;
  selectedId: number;
}
const SelectAddressModal: React.FC<SelectReciverModalProps> = (
  props: SelectReciverModalProps
) => {
  const {
    loadAddress,
    loading,
    userAddress,
    deleteAddress,
    updateUserAddress,
  } = useCustomerInfo();
  const { bussinessName } = useParams();
  const shopInfo = useAppSelector((state) => state.shopInfo);
  const [showLocationModal, setShowLocation] = useState<boolean>(false);
  const finalPathName = "/" + bussinessName;
  const { t } = useTranslation();
  const [selectedOutlet, setSelectedOutlet] = useState<any>({});
  const [newId, setNewId] = useState<number>(0);
  const { onPressClose, accesssToken, customerId, selectedLatLng, selectedId } =
    props;
  const [showNewReciverModal, setShowNewReciverModal] =
    useState<boolean>(false);
  const hideModalHandler = () => {
    setShowNewReciverModal(false);
  };
  const onSaveAddressHandler = (action: any, data: any) => {
    setNewId(data?.id);
  };
  const showAddressModal = () => {
    setShowLocation(true);
  };
  const deleteAddressHandler = (addressId: string) => {
    deleteAddress(accesssToken, addressId).then((success) => {
      if (success) {
        onPressClose(undefined, "delete");
        loadAddress(accesssToken, parseInt(customerId));
      }
    });
  };
  const onChangeOutlet = (selectedOutlet: any) => {
    setSelectedOutlet(selectedOutlet);
    setShowNewReciverModal(true);
  };
  const checkAvailableAddress = (lat_lng: any) => {
    var is_found = false;
    var lat_lng1 = lat_lng?.split(",");
    try {
      if (lat_lng !== undefined) {
        // @ts-ignore
        var lat_lng1 = lat_lng?.split(",");
        if (lat_lng1) {
          $.each(shopInfo.delivery_zones, function (outleName, outLetData) {
            // eslint-disable-next-line no-undef
            const eachOutletLatLng = new google.maps.Polygon({
              paths: JSON.parse(outLetData.lat_lng),
            });
            // eslint-disable-next-line no-undef
            is_found = google.maps.geometry.poly.containsLocation(
              //@ts-ignore
              // { lat: 25.14364341760868, lng: 56.326893533530544 },
              { lat: parseFloat(lat_lng1[0]), lng: parseFloat(lat_lng1[1]) },
              eachOutletLatLng
            )
              ? true
              : false;
            if (is_found) {
              // @ts-ignore
              // foun_name = outleName;
              // eslint-disable-next-line no-throw-literal
              throw "Found";
            }
          });
        }
      }
    } catch (e) {
      if (e !== "Found") throw e;
    }
    if (is_found) {
      return true;
    } else {
      return false;
    }
  };
  const getDeliveryZonseInfoHandler = (addressSelected: any) => {
    // var is_found = false;
    // var delivery_fee = 0;
    // var foun_name = "";
    var lat_lng1 = addressSelected.selected_lat_lng.split(",");
    getDeliveryZonseInfo(shopInfo, shopInfo.delivery_zones, {
      lat: parseFloat(lat_lng1[0]),
      lng: parseFloat(lat_lng1[1]),
    }).then(async ({ is_found, center, foun_name, deliveryZoneData }) => {
      // console.log(is_found, center);
      if (is_found) {
        //
        await selectedOutInfo(
          foun_name,
          deliveryZoneData,
          await getGeocodeLoc(center!),
          center!,
          //@ts-ignore,
          shopInfo,
          finalPathName
        );
        await saveLabelAndAddressToStorage(addressSelected, bussinessName!);
        onPressClose(addressSelected, "select");
        updateUserAddress(addressSelected.id, customerId, accesssToken);
      } else {
        // alert("Location not found please select another one");
        // setShowError(true);
      }
    });
  };
  useEffect(() => {
    if (!showNewReciverModal) {
      loadAddress(accesssToken, parseInt(customerId)).then(() => {});
    }
  }, [showNewReciverModal]);
  useEffect(() => {
    // Object.entries(userAddress).forEach((element) => {
    //   console.log(element[1].id);
    //   // if (element.id === newReceiverId) {
    //   //   console.log(element);
    //   //   onPressClose(element, "select");
    //   //   return;
    //   // }
    // });
    if (newId !== 0 && Object.keys(userAddress).length > 0) {
      Object.entries(userAddress).forEach((element) => {
        if (element[1]?.id !== undefined && element[1]?.id === newId) {
          getDeliveryZonseInfoHandler(element[1]);
          onPressClose(element[1], "select");
          updateUserAddress(element[1].id, customerId, accesssToken);
          // 'hideModalHandler
          // hideModalHandler();
          return;
        }
      });
    }
  }, [userAddress, newId]);
  return (
    <>
      <div
        id="pop_delivery"
        className="pop_up_maps_main pop_main_bg pop_main_menu_bg"
      >
        <div className="popup_delivery popup_from_bottom popup_slide">
          <div className="content" id="">
            <br />
            <div className="container">
              <div>
                {/* <div className="delivery_head">{t("Select")}</div> */}
                <div
                  style={{ paddingTop: 20, paddingBottom: 20 }}
                  className="delivery_close"
                  onClick={() => onPressClose(undefined, "close")}
                >
                  <a className="slide_remove">&times;</a>
                </div>
              </div>
            </div>
            {Object.keys(userAddress).length !== 0 ? (
              Object.entries(userAddress)?.map((item, index) => {
                // console.log(item[1]);
                return (
                  <>
                    {item[1].selected_lat_lng !== undefined && (
                      <button
                        style={{ width: "90%" }}
                        className={`receiver-wrapper ${
                          // getDeliveryZonseHandler(item[1].selected_lat_lng) &&
                          !checkAvailableAddress(item[1].selected_lat_lng) &&
                          "unavailable-address"
                        }`}
                      >
                        <button
                          style={{
                            width: "90%",
                            display: "flex",
                            flexDirection: "row",
                          }}
                          onClick={() => getDeliveryZonseInfoHandler(item[1])}
                          disabled={
                            !checkAvailableAddress(item[1].selected_lat_lng)
                          }
                        >
                          <div
                            style={{ marginRight: 10 }}
                            className="glyphicon glyphicon-map-marker f_size_24"
                          />
                          <div
                            style={{
                              flexDirection: "column",
                              display: "flex",
                              alignItems: "flex-start",
                            }}
                          >
                            {/* color: "#7a7e8a" */}
                            <text
                              style={{ fontSize: 16 }}
                              className={`${
                                selectedId === item[1].id
                                  ? "text-color-store"
                                  : ""
                              }`}
                            >
                              {item[1].label}
                            </text>
                            <text
                              className={`${
                                selectedId === item[1].id
                                  ? "text-color-store"
                                  : ""
                              }`}
                            >
                              {item[1].address}
                            </text>
                          </div>
                        </button>

                        {Object.keys(userAddress).length > 2 && (
                          <svg
                            onClick={() => {
                              deleteAddressHandler(item[1].id?.toString());
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1000 1000"
                            fill="currentColor"
                            data-spec="icon-plus"
                            className="w-5 h-5"
                            style={{ width: 12, height: 12 }}
                          >
                            <path
                              fill="orange"
                              d="M844.9 233.4c-115.10000000000002 0.5-230.19999999999993 0.29999999999998295-345.29999999999995 0.29999999999998295v-0.09999999999999432h-345.3c-11.900000000000006 0-23.100000000000023-1.5999999999999943-20.100000000000023 17.400000000000006 17 107.69999999999999 33.20000000000002 215.5 49.80000000000001 323.20000000000005 16.30000000000001 106.39999999999998 35.19999999999999 212.39999999999998 48.099999999999994 319.0999999999999 6.700000000000017 55.80000000000007 53.900000000000006 107.70000000000005 118.00000000000003 106.70000000000005 99.19999999999999-1.6000000000000227 198.29999999999995-0.10000000000002274 297.5-0.5 66.69999999999993-0.2999999999999545 109.5-38.5 119.29999999999995-104.60000000000002 19.800000000000068-132.79999999999995 39.700000000000045-265.6 59.80000000000007-398.4 12.199999999999932-80.69999999999999 24.199999999999932-161.39999999999998 37.5-241.9 2.8999999999999773-18.19999999999999-2.800000000000068-21.19999999999999-19.300000000000068-21.19999999999999z m-317.19999999999993 149.4c-0.7000000000000455 160.90000000000003-0.10000000000002274 321.8-0.20000000000004547 482.7h-55.10000000000002c-0.0999999999999659-80.10000000000002-0.0999999999999659-160.29999999999995-0.0999999999999659-240.39999999999998h0.19999999999998863c0-82.39999999999998 0.5-164.8-0.39999999999997726-247.20000000000005 0-2.5 0.0999999999999659-4.599999999999966 0.2999999999999545-6.599999999999966h54.60000000000002c0.5 3.3000000000000114 0.7000000000000455 7.199999999999989 0.7000000000000455 11.5z m-288.90000000000003-11.5h55c1.3000000000000114 3.8000000000000114 2.099999999999966 8.300000000000011 2.8000000000000114 13.599999999999966 14.099999999999966 113.80000000000001 30.399999999999977 227.30000000000007 46.19999999999999 340.9 6.5 46.60000000000002 13.800000000000011 93 19.5 139.70000000000005h-55.69999999999999c-15-107.79999999999995-30.100000000000023-215.5-45-323.29999999999995-7.800000000000011-56.30000000000007-15.000000000000028-112.70000000000005-22.600000000000023-169.10000000000002l-0.19999999999998863-1.8000000000000114z m493.8 200.2c-13.600000000000023 98-28.399999999999977 195.79999999999995-40.200000000000045 294h-55.60000000000002c22.700000000000045-161.60000000000002 44.30000000000007-323.29999999999995 66.40000000000009-484.9 0.39999999999997726-2.8000000000000114 0.39999999999997726-6.100000000000023 0.6999999999999318-9.300000000000011h56.89999999999998c-0.599999999999909 4-1.7999999999999545 8.300000000000011-2.2999999999999545 11.800000000000011-8.399999999999977 62.89999999999998-17.100000000000023 125.69999999999999-25.899999999999977 188.39999999999998z m208.89999999999998-413.7c-10.799999999999955-25.700000000000017-28.5-46.80000000000001-48.200000000000045-66.10000000000001-21.5-21-45.799999999999955-33-77.39999999999998-32.2-60.799999999999955 1.5-121.60000000000002 0-182.39999999999998 0.5-13.200000000000045 0.10000000000000142-20.399999999999977-1.7999999999999972-24.5-16.6-8.5-30.599999999999998-27.700000000000045-43.199999999999996-59.299999999999955-43.3-34-0.10000000000000142-68.00000000000006-0.20000000000000143-102.00000000000006 0.09999999999999859-29.80000000000001 0.2-49.39999999999998 14.100000000000001-57.599999999999966 42.8-3.900000000000034 13.600000000000001-10 17.6-24.100000000000023 17.4-60.80000000000001-1-121.6-1-182.3-0.3999999999999986-53.5 0.5-116.79999999999998 53.3-128.7 105.5-3.6000000000000014 16.099999999999994 2 25.400000000000006 17.700000000000003 28.30000000000001 7.799999999999997 1.3999999999999773 15.799999999999997 1.5 23.700000000000003 1.5 133.9 0.09999999999999432 267.79999999999995 0.09999999999999432 401.6 0h182.29999999999995l184.5 0.09999999999999432c18.100000000000023 0 36.30000000000007 0.5 54.200000000000045-0.9000000000000057 24.600000000000023-1.9000000000000057 31.899999999999977-14.400000000000006 22.5-36.69999999999999z"
                            />
                          </svg>
                        )}
                      </button>
                    )}
                  </>
                );
              })
            ) : (
              <div className="receiver-wrapper">
                <text>{t("no_address_message")}</text>
              </div>
            )}
            <br />
            <br />
          </div>
        </div>
        {showNewReciverModal && (
          <PopSelectAddress
            onSaveAddressClose={(action, data) => {
              onSaveAddressHandler(action, data);
            }}
            selectedLatLng={selectedOutlet.selectedLatLon}
            onPressClose={hideModalHandler}
          />
        )}
        {showLocationModal && (
          <PopDelivery
            restoData={shopInfo}
            onSelectedOutlet={(selectedOutlet: any) => {
              onChangeOutlet(selectedOutlet);
            }}
            onPressClose={() => {
              setShowLocation(false);
            }}
          />
        )}
        <div className="address-modal-addnew" onClick={showAddressModal}>
          <div className=" target_slide glyphicon glyphicon-chevron-right"></div>
          <text style={{ marginLeft: 5, fontSize: 12 }}>
            {t("add_new_address")}
          </text>
        </div>
      </div>
    </>
  );
};

export default SelectAddressModal;
